// extracted by mini-css-extract-plugin
export default {"wrapper":"Overlay_wrapper__58URF","spinner":"Overlay_spinner__Fk8ir"};